//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectFace.js";
import "../no/SelectTaggedObject.js";
import "../no/SketchExpressionModifierBuilder.js";
import "../no/SelectObject.js";
import "../no/SketchExpressionModifierBuilder.js";
let d=[[[0,"CoordSystem",1,"CoordinateSystem",0],[0,"KeepCoordSystem",1,0],[0,"KeepSelectCSYSFace",1,0],[0,"KeepSelectGuideCurve",1,0],[0,"KeepSelectTargetFace",1,0],[0,"PlacementType",1,0],[1,"SelectCSYSFace",0,"SelectFace",0],[1,"SelectGuideCurve",0,"SelectTaggedObject",0],[1,"SelectTargetFace",0,"SelectFace",0],[1,"SketchBlock",0,"SketchExpressionModifierBuilder",0],[0,"WeldLocation",1,"Point",0]],[],[]];
SPLM.Features.ShipDesign.WeldCutBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.WeldCutBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.WeldCutBuilder.CreationMethod = Object.freeze({
    "Corner" : "Corner", "AlongGuide" : "AlongGuide", "SpecifyCSYS" : "SpecifyCSYS"});

export default SPLM;